<template>
    <Modal
        title="工单详情"
        v-model="dialogShow"
        :mask-closable="false"
        @on-visible-change="changeHandle"
    >
        <div class="dialog-con">
            <div class="work-title">
                <div class="title1">{{ siteName || "空" }}</div>
                <div class="status">{{ urgencyLevelMap[urgencyLevel] }}</div>
            </div>
            <div class="date">{{ timeStamp(createDate) }}</div>
            <div class="status-img">
                <img src="@/assets/shtg.png" v-if="status==1" alt="">
                <img src="@/assets/dcl.png" v-else-if="status==0 && !flowList.length" alt="">
                <img src="@/assets/dsh.png" v-else-if="status==0 && flowList.length" alt="">
            </div>

            <div class="content-b">
                <div class="title2">问题描述</div>
                <div class="content-d">{{ remark }}</div>
                <div class="list">
                    <div class="pic-b" v-for="(item, index) in imgurl" :key="index"><a :href="item" target="_blank"><img :src="item" alt=""></a></div>
                </div>
            </div>

            <div class="flow-b">
                <div class="title2">处理状态</div>
                <div class="flow-list">
                    <div class="flow-item" v-for="(item, index) in flowList" :key="index">
                        <div class="leftsign">
                            <div class="circle"></div>
                            <div class="line" v-if="index !== flowList.length-1"></div>
                        </div>
                        <div class="rightdd">
                            <div class="flow-h">
                                <div class="user">{{ item.realName || "无" }}</div>
                                <div class="dd">{{ timeStamp(item.time) }}</div>
                            </div>
                            <div class="flow-stat">{{ item.title }}</div>
                            <div class="remakr">{{ item.remark || "无" }}</div>

                            <div class="flow-piclist">
                                <div class="pic-b" v-for="(src, index) in item.pictures" :key="src || index"><a :href="src" target="_blank"><img :src="src" alt=""></a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="reply">
                <div class="title2" style="margin-bottom: 6px;">处理回复</div>
                <Upload
                    multiple
                    type="drag"
                    action="/api/upload?dir=inspection"
                    :on-success="upImgSuccess"
                    :on-remove="handleRemove"
                    :with-credentials="true"
                >
                    <div style="padding: 20px 0;background: #E6EFFF;">
                        <img src="@/assets/photo.png" alt="">
                        <p style="color: #165DFF;font-size: 14px;">上传照片</p>
                    </div>
                </Upload>
            </div>

            <i-input v-model="formValidate.remark" type="textarea" :rows="4" placeholder="输入备注"></i-input>
        </div>
        <div slot="footer">
            <i-button style="margin-left: 1em;" @click="dialogShow = false">取消</i-button>
            <i-button type="primary" style="margin-left: 1em;" :loading="replyLoadng" @click="replyHandle">回复</i-button>
            <i-button type="success" style="margin-left: 1em;" :loading="workLoading" @click="completeWork">工单完结</i-button>

        </div>
    </Modal>
</template>

<script>
import { urgencyLevelMap } from "./dict";
import { timeStamp } from "../../../util/common/date";

export default {
    data() {
        return {
            replyLoadng: false,
            workLoading: false,
            urgencyLevelMap: urgencyLevelMap,
            remark: null,
            dialogShow: false,
            flowList: [
            ],
            imgurl: [],
            createDate: null,
            siteName: null,
            urgencyLevel: null,
            status: null,
            formValidate: {
                imgurl: [],
                remark: null
            },
            id: null
        }
    },
    methods: {
        timeStamp,
        open(row) {
            this.dialogShow=true
            let replyList = row.replyList ? row.replyList : [];
            this.flowList = replyList.map(item => {
                return {
                    ...item,
                    pictures: item.pictures.split(",")
                }
            });
            this.imgurl = row.imgurl.split(",");
            this.remark = row.remark;
            this.createDate = row.createDate;
            this.siteName = row.siteName;
            this.urgencyLevel = row.urgencyLevel;
            this.status = row.status;
            this.id = row.id;
        },
        replyHandle() {
            if (!this.formValidate.imgurl.length) {
                this.$Message.warning("请上传图片");
                return
            }
            if (!this.formValidate.remark) {
                this.$Message.warning("请填写备注");
                return
            }
            this.replyLoadng = true;
            this.$api.Event.replyWorkApi({
                content: {
                    id: this.id,
                    replyPics: this.formValidate.imgurl.map(item => item.response).join(","),
                    replyContent: this.formValidate.remark
                }
            }, ["uuid", "company"]).then(res => {
                if (res.code == 0) {
                    this.$Message.success("回复完成");
                    this.dialogShow = false;
                    this.$emit("success")
                } else {
                    this.$Message.warning(res.message);
                }
            }).finally(() => {
                this.replyLoadng = false
            })
        },
        completeWork() {
            this.workLoading = true;
            this.$api.Event.completeWorkApi({
                id: this.id,
                content: {
                }
            }, ["uuid", "company"]).then(res => {
                if (res.code == 0) {
                    this.$Message.success("提交成功");
                    this.dialogShow = false;
                    this.$emit("success")
                } else {
                    this.$Message.warning(res.message);
                }
            }).finally(() => {
                this.workLoading = false
            })
        },
        upImgSuccess(res, file) {
            if (!res.code) {
                this.formValidate.imgurl.push(file);
            } else {
                this.$Notice.warning({
                    title: "上传失败",
                    desc: res.message
                });
            }
        },
        handleRemove(res) {
            this.formValidate.imgurl.splice(
                this.formValidate.imgurl.findIndex(item => item.response === res.response),
                1
            )
        },
        changeHandle(flag) {
            if (!flag) {
                this.formValidate.imgurl = [];
                this.formValidate.remark = "";

                this.flowList = [];
                this.imgurl = [];
                this.remark = "";
                this.createDate = "";
                this.siteName = "";
                this.urgencyLevel = "";
                this.status = "";
                this.id = null;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .ivu-modal-content {
    background: url(../../../assets/BG.png) no-repeat;
    background-color: #fff;
    background-position: top right;
}
.dialog-con {
    font-size: 14px;
    position: relative;
}
.title1 {
    font-size: 18px;
    font-weight: 600;
}
.title2 {
    font-size: 14px;
    font-weight: 600;
}
.work-title {
    display: flex;
    align-items: center;
    .status {
        font-size: 12px;
        background: red;
        color: #fff;
        border-radius: 6px;
        padding: 2px 6px;
        transform: scale(0.7);
    }
}
.date {
    font-size: 12px;
    color: #999999;
}
.status-img {
    position: absolute;
    top: 10px;
    right: 20px;
    width: 66px;
    img {
        width: 100%;
    }
}
.content-b {
    margin-top: 25px;
    .content-d {
        font-size: 12px;
        color: #666666;
        line-height: 24px;
    }
    .list {
        display: flex;
        flex-wrap: wrap;
        .pic-b {
            margin-right: 10px;
            margin-bottom: 10px;
            width: 60px;
            height: 60px;
            overflow: hidden;
            background: #eaeaea;
            img {
                width: 100%;
            }
        }
    }
}
.flow-b {
    .flow-list {
        .flow-item {
            display: flex;
            position: relative;
           .leftsign {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: absolute;
                left: 0;
                top: 8px;
                height: 100%;
                width: 10px;
                // padding-top: 8px;
                .circle {
                    width: 4px;
                    height: 4px;
                    border-radius: 50%;
                    background: #D8D8D8;
                }
                .line {
                    width: 1px;
                    flex: 1;
                    background: #D8D8D8;
                }
           }
           .rightdd {
            padding-left: 16px;
            flex: 1;
            .flow-piclist {
                margin-top: 10px;
                display: flex;
                flex-wrap: wrap;
                .pic-b {
                    margin-right: 10px;
                    margin-bottom: 10px;
                    width: 60px;
                    height: 60px;
                    overflow: hidden;
                    background: #eaeaea;
                    img {
                        width: 100%;
                    }
                }
            }
           }
           .flow-h {
                display: flex;
                justify-content: space-between;
                align-items: center;
                
                .dd {
                    color: #999;
                    font-size: 12px;
                }
                
           }
           .flow-stat {
                color: #999;
                font-size: 12px;
            }
            .remakr {
                padding: 6px 10px;
                background: #d8d8d8;
                font-size: 12px;color: #999;
            }
        }
    }
}
.reply {
    margin-top: 25px;
}
</style>